import {
  Home,
  LayoutDashboard,
  ShoppingBag,
  Mail,
  Layers,
} from 'lucide-react'
import { createElement } from 'react'
import { paths } from 'src/routes/paths'

export const isActive = (pathname: string, href: string): boolean => {
  if (href === paths.home || href === '/') {
    return (
      pathname === '/' ||
      pathname.startsWith('/s/') ||
      pathname.startsWith('/start/')
    )
  }

  return pathname === href || pathname.startsWith(href + '/')
}

export const getNavIcon = (href: string) => {
  if (href === paths.home || href === '/') return createElement(Home, { className: 'h-5 w-5' })
  if (href === paths.platform) return createElement(LayoutDashboard, { className: 'h-5 w-5' })
  if (href === '#') return createElement(Layers, { className: 'h-5 w-5' })
  if (href === paths.allProducts) return createElement(ShoppingBag, { className: 'h-5 w-5' })
  if (href === paths.contact) return createElement(Mail, { className: 'h-5 w-5' })
  return null
}
